"use client";

import { useState, useCallback } from "react";

const PAGE_OPTIONS = [25, 50, 100, 150];
const STORAGE_KEY = "meowmi-page-size";
const DEFAULT_SIZE = 50;

function loadSaved() {
  if (typeof window === "undefined") return DEFAULT_SIZE;
  try {
    const n = Number(localStorage.getItem(STORAGE_KEY));
    return PAGE_OPTIONS.includes(n) ? n : DEFAULT_SIZE;
  } catch {
    return DEFAULT_SIZE;
  }
}

export function usePageSize() {
  const [pageSize, setPageSizeState] = useState(loadSaved);

  const setPageSize = useCallback((size) => {
    const n = Number(size);
    if (!PAGE_OPTIONS.includes(n)) return;
    setPageSizeState(n);
    try {
      localStorage.setItem(STORAGE_KEY, String(n));
    } catch {}
  }, []);

  return { pageSize, setPageSize, PAGE_OPTIONS };
}

/** 分頁選擇器 UI（放在分頁按鈕旁邊） */
export function PageSizeSelect({
  pageSize,
  onChange,
  options = PAGE_OPTIONS,
  label = "每頁顯示張數",
}) {
  return (
    <select
      value={pageSize}
      onChange={(e) => onChange(Number(e.target.value))}
      aria-label={label}
      className="text-sm px-2 py-1.5 outline-none"
      style={{
        backgroundColor: "var(--color-bgSecondary)",
        color: "var(--color-textSecondary)",
        border: "1px solid var(--color-cardBorder)",
        borderRadius: "var(--radius-sm)",
        cursor: "pointer",
      }}
    >
      {options.map((n) => (
        <option key={n} value={n}>
          每頁 {n} 張
        </option>
      ))}
    </select>
  );
}
